/*
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import AppService from '@/services/app';
import Store from '@/store/index';

export default { 

  resetPending() {
    // reset store to empty
    Store.dispatch('driverPayments/setPendingPayments', {
      payments: [],
    });
  }, 

  async listPending(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['driverPayments/pendingPayments'].length < 1) {
      try {
        const response = await Api(true).get('/driver/payment/list_pending');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetPending();
            return response.data.message;
          } else {
            Store.dispatch('driverPayments/setPendingPayments', {
              payments: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetPending();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('driverPayments.ts - listPending - 46 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  resetApproved() {
    // reset store to empty
    Store.dispatch('driverPayments/setApprovedPayments', {
      payments: [],
    });
  }, 

  async listApproved(refreshFromAPI: boolean) {
    // check if we need to force an API refresh or have already fetched this data and it is in the Store
    if (refreshFromAPI || Store.getters['driverPayments/approvedPayments'].length < 1) {
      try {
        const response = await Api(true).get('/driver/payment/list_batch');
        
        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            this.resetApproved();
            return response.data.message;
          } else {
            Store.dispatch('driverPayments/setApprovedPayments', {
              payments: response.data,
            });
            return '';
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        this.resetApproved();
        if (error.response) {
          return error.response.statusText;
        } else {
          AppService.logSupportDebug('driverPayments.ts - listApproved - 89 - ' + error);
          return Store.getters['app/messages'].couldNotConnect;
        }
      } 
    } else {
      // this data is ready to access in the Store
      return '';
    }
  },

  create(params: {
    loadId: number,
    driverId: number,
    from: string,
    to: string,
    distance: number,
  }) {
    return Api(true).post('/driver/payment/create', params);
  },

  update(params: {
    id: number,
    driverId: number,
    from: string,
    to: string,
    distance: number,
  }) {
    return Api(true).post('/driver/payment/update', params);
  },

  delete(params: {
    ids: string,
  }) {
    return Api(true).post('/driver/payment/delete', params);
  },

  approve(params: {
    id: number,
  }) {
    return Api(true).post('/driver/payment/approve', params);
  },

  finalise(params: {
    ids: string,
  }) {
    return Api(true).post('/driver/payment/finalise', params);
  },

  search(config: {params: { 
    driverId: number,
    loadNumber: string,
    startDate: string,
    endDate: string,
  }}) {
    return Api(true).get('/driver/payment/search', config);
  },


}
